import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from './firebase';

export const logAudit = async (action, resourceId, details = {}) => {
  try {
    const user = auth.currentUser;
    await addDoc(collection(db, 'auditLogs'), {
      action,
      resourceId,
      details,
      userId: user?.uid || null,
      userEmail: user?.email || null,
      timestamp: serverTimestamp(),
    });
  } catch (e) {
    console.error('Audit log yazılamadı:', e);
  }
};
